    /**
 * Page footer directive
 * To control its state (open/close) use flag in router states - footer: true/false
 */
app.directive('appFooter', ['$state', '$ionicSideMenuDelegate', '$document', '$timeout',
    function ($state, $ionicSideMenuDelegate, $document, $timeout) {

        var domElement, defaultTab;

        return {

            link: function (scope, element) {
                scope.activeIndicator = {};

                $document.ready(function () {
                    domElement = element[0];
                    defaultTab = domElement.getElementsByClassName('tab')[0];
                    $timeout(setDefaultIndicator, 0);
                });

                function setDefaultIndicator() {
                    defaultTab = domElement.getElementsByClassName('tab')[0];
                    scope.activeIndicator = {
                        width: defaultTab.offsetWidth + 'px',
                        left: 0
                    };
                    console.info(scope.activeIndicator, 3);
                }

                scope.state = true;
                scope.active = $state.current.name;

                var stateWatch = scope.$watch(function () {
                    return $state.$current.name
                }, function () {
                    scope.state = $state.current.data && $state.current.data.footer;
                    scope.active = $state.current.name;
                });

                scope.switchIndicator = function (state) {
                    var activeTab = domElement.getElementsByClassName(state)[0];
                    scope.activeIndicator = {
                        width: defaultTab.offsetWidth + 'px',
                        left: activeTab.offsetLeft + 'px',
                        right: (activeTab.offsetLeft + defaultTab.offsetWidth) + 'px'
                    };
                    $state.go('root.app.'+state);
                };

                scope.openSideMenu = function () {
                    $ionicSideMenuDelegate.toggleRight();
                };

                //reset indicator to first element
                scope.$on('clear', function () {
                    console.log('reset active element on clear');
                    scope.activeIndicator = {
                        width: defaultTab.offsetWidth + 'px',
                        left: 0
                    }
                });

                element.on('$destroy', function () {
                    stateWatch();
                });

            },
            templateUrl: 'templates/directives/appFooter.html'
        }
    }]);